import appConfig from "@/config";
import Cookie from "js-cookie";
import { getOS, getBrowser } from "@/libs/user-agent";
import { setToken } from "./util";

export default options => {
  let token = Cookie.get(appConfig.cookie.TOKEN);
  if (!options.headers) options.headers = {};
  if (token) {
    options.headers[appConfig.headers.ACCESS_TOKEN] = token;
    // 重新更新cookie(后端只有在登录的时候设置token过期时间过期，其它时间不更新)，避免时间过期
    setToken(token);
  }
  // 携带浏览器标识
  let browser = getBrowser();
  if (browser) {
    options.headers[appConfig.headers.BROWSER] = encodeURIComponent(browser);
  }
  let os = getOS();
  if (os) {
    options.headers[appConfig.headers.OS] = encodeURIComponent(os);
  }
};



// WEBPACK FOOTER //
// ./src/libs/before-request.js